import { Stack } from "@mui/material";
import BreakLogItem from "./BreakLogItem";

const BreakLogList = ({
  breakData,
  expandedBreak,
  onExpandClick,
  detailsPageMap,
  detailsPerPage,
  onDetailsPageChange,
}) => {
  return (
    <Stack spacing={2}>
      {breakData.map((breakLog, index) => {
        const isExpanded = expandedBreak === index;
        const detailsPage = detailsPageMap[index] || 1;

        return (
          <BreakLogItem
            key={index}
            breakLog={breakLog}
            index={index}
            isExpanded={isExpanded}
            onExpandClick={onExpandClick}
            detailsPage={detailsPage}
            detailsPerPage={detailsPerPage}
            onDetailsPageChange={onDetailsPageChange}
          />
        );
      })}
    </Stack>
  );
};

export default BreakLogList;
